import React, { useState, useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
//styles
import styles from 'src/asset/scss/styles/notify.module.scss';
//hook
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//CompWrapper
import Section from 'src/webapp/views/wrapper/Section';
import Container from 'src/webapp/views/wrapper/Container';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
import ActiveButtonWrapper from 'src/webapp/views/wrapper/ActiveButtonWrapper';
//Comp
import Menu from 'src/webapp/views/component/Menu';//메뉴
import Titlebar from 'src/webapp/views/component/Titlebar';//상단타이틀
import Element from 'src/webapp/views/wrapper/Element';
import InViewData from 'src/webapp/views/component/data/InViewData';//데이터로드확인
import CouponList from './CouponList';

export default function Banner() {
    const { axiosPostHandler } = useAxiosHook();//axios
    /* ====================쿠폰리스트API ==================== */
    const pageRef = useRef(20);
    const isLock = useRef(false);
    const [couponList, setCouponList] = useState(null);
    const memberCouponListAPI = async () => {
        if (isLock.current || !pageRef.current) { return; }
        const rownum = pageRef.current;
        
        try {
            isLock.current = true;
            
            const DATA = { STATE: 2, ROWNUM: pageRef.current };
            const result = await axiosPostHandler(`siteCouponListForAdmin.do`, DATA);
            /* ===== 결과처리 ===== */
            const isOk = result && result.message === "SUCCESS";
            const newList = isOk ? result.data : [];
            setCouponList(prev => Array.isArray(prev) ? [...prev, ...newList] : [...newList]);
            pageRef.current = (isOk && result.data?.length >= 20) ? rownum + 20 : null;
        } finally {
            isLock.current = false;
        }
    }
    
    /* ========== useEffect 초기 실행 ========== */
    useEffect(() => {
        memberCouponListAPI();
    }, [])
    /* ========== useEffect 초기 실행 ========== */
    /* ========== useEffect inView처리 ========== */
    const [inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if(!inView || pageRef.current === null || !couponList || isLock.current){return;}
        memberCouponListAPI();
    }, [inView])
    /* ========== useEffect inView처리 ========== */
    /* ====================쿠폰리스트API ==================== */
    return (
        <>
            <Section>
                <Menu />{/* 메뉴 */}
                <Container>
                    <FixedPanel>
                        <Titlebar title={`쿠폰 관리`} dept={[{ label: '기타' }, { label: '쿠폰 관리' }]} />{/* 상단타이틀 */}
                    </FixedPanel>
                    <FlickPanel className={styles.flickPanel}>
                        <ActiveButtonWrapper>
                            <Element tag={`div`} >
                                <Link to={'reg'}><span>쿠폰 등록</span></Link>
                            </Element>
                        </ActiveButtonWrapper>
                        <CouponList list={couponList} setList={setCouponList} />
                        {couponList?.length > 0 && pageRef.current != null ? <div ref={inViewRef}><InViewData inView={true} /></div>
                            : pageRef.current === null ? <InViewData readAll={true} />
                                : null}
                    </FlickPanel>
                </Container>
            </Section>
        </>
    )
}